<template>
  <PSComponentHeadSelect />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
